var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from "react";
import { initializeApp } from "firebase/app";
import { getAuth, createUserWithEmailAndPassword, } from "firebase/auth";
import { DevDaemonDBController } from "../DevDaemonDBController";
import { firebaseConfig } from "../FirebaseConfig";
import { useAuthContext } from "../AuthContext";
import { useHistory } from "react-router-dom";
import FormBox from "../components/FormBox";
import Button from "../components/Button";
import "./SignUp.css";
function SignUp() {
    var _a = useState(""), userName = _a[0], setUserName = _a[1];
    var _b = useState(""), email = _b[0], setEmail = _b[1];
    var _c = useState(""), password = _c[0], setPassword = _c[1];
    var db_ctrler = useAuthContext().db_ctrler;
    var history = useHistory();
    var handleSubmit = function (event) {
        event.preventDefault();
        var app = initializeApp(firebaseConfig);
        var auth = getAuth(app);
        var defaultSignUpTransaction = function (userCredential) {
            // Signed in
            db_ctrler = new DevDaemonDBController(app);
            var user_info = userCredential.user;
            db_ctrler.createNewMasterUserData(user_info.uid, {
                defaultDisplayName: userName,
                defaultIconURL: "http://www.w3.org/2000/svg",
                lastUpdate: new Date(),
            });
            history.push("/checkstatus");
        };
        createUserWithEmailAndPassword(auth, email, password)
            .then(defaultSignUpTransaction)
            .catch(function (error) {
            alert("\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u4F5C\u308C\u307E\u305B\u3093\u3067\u3057\u305F (Code:" + error.code + ")\n" + error.message);
        });
    };
    return (_jsxs("div", __assign({ className: "signup-style" }, { children: [_jsx("h4", { children: "\u30A2\u30AB\u30A6\u30F3\u30C8\u4F5C\u6210" }, void 0), _jsxs("form", __assign({ onSubmit: handleSubmit }, { children: [_jsx(FormBox, { name: "user", type: "text", placeholder: "\u30E6\u30FC\u30B6\u30FC\u540D", onChange: setUserName }, void 0), _jsx(FormBox, { name: "email", type: "email", placeholder: "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9", onChange: setEmail }, void 0), _jsx(FormBox, { name: "password", type: "password", placeholder: "\u30D1\u30B9\u30EF\u30FC\u30C9", onChange: setPassword }, void 0), _jsx(Button, { title: "\u65B0\u898F\u30C1\u30FC\u30E0\u4F5C\u6210", button_size: "medium-size", text_color: "text-dark", bg_color: "bg-yellow" }, void 0)] }), void 0)] }), void 0));
}
export default SignUp;



//////////////////
// WEBPACK FOOTER
// ./src/pages/SignUp.tsx
// module id = 62
// module chunks = 0